import { createContext, useContext } from "react";
import { PatientStore } from "./patientStore";

const PatientContext = createContext<PatientStore | undefined>(undefined);

interface StoreProviderProps {
  children: React.ReactNode;
}

const patientStore = new PatientStore();

export const PatientProvider = ({ children }: StoreProviderProps) => <PatientContext.Provider value={patientStore}>
  {children}
</PatientContext.Provider>


export const usePatient = () => useContext(PatientContext);